import type { Meta, StoryFn } from '@storybook/react';
import type { HorizontalListProps } from './HorizontalList';

import { HorizontalList } from './HorizontalList';

import { Button } from 'components/Buttons';
import { Icon } from 'components/Icon';

const codeString = '<HorizontalList values={values} separator="•" />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/HorizontalList',
  component: HorizontalList,
  argTypes: {
    separator: {
      control: 'text',
    },
  },
  parameters: {
    inspectComponent: HorizontalList,
    codeString: codeString,
  },
} as Meta<HorizontalListProps>;

const Template: StoryFn<HorizontalListProps> = (args) => <HorizontalList {...args} />;

export const HorizontalListExample = Template.bind({});
HorizontalListExample.args = {
  values: ['Curabitur consequat', 'Lectus sit amet luctus vulputate', 'Nisi semi mattis'],
};

export const WithComplexContent = Template.bind({});
WithComplexContent.args = {
  values: [
    <a href="/?path=/story/atoms-horizontallist--with-complex-content" key="1">
      Curabitur consequat
    </a>,
    <Button type="button" variant="primary" key="2">
      Lectus sit amet luctus vulputate
    </Button>,
    <Icon name="Sparkles" key="3" />,
    <strong key="4">Nisi semi mattis</strong>,
  ],
  separator: <Icon name="CheveronRight" size={16} />,
};

WithComplexContent.argTypes = {
  ...WithComplexContent.argTypes,
  separator: {
    table: {
      disable: true, // Disable separator controls for this specific story
    },
  },
};
